export default __webpack_public_path__ + "img/search_nomatches.e0ec5041.svg";